// import PropTypes from 'prop-types'; -> NO PROP-TYPES, this is only a WRAPPER for MATCH-CHANGE-LMP and MATCH-CHANGE-HP
import React from 'react';

import {
  Color,
  COLOR_SCHEMA_DARK,
  COLOR_SCHEMA_DARK_LIGHT,
  COLOR_SCHEMA_LIGHT,
  FontSize,
  FontWeight,
} from '../../../typings/design-tokens';

import { IMatchChangeHp, MATCH_CHANGE_TYPE_HP, MatchChangeHp } from './match-change-hp';
import { IMatchChangeLmp, MATCH_CHANGE_TYPE_LMP, MatchChangeLmp } from './match-change-lmp';

import './match-change.scss';

// COLORS/FONTS for all VARIANTS
export const DEFAULT_COLOR: Color = 'light';
export const DEFAULT_FONT_SIZE: FontSize = '14';
export const DEFAULT_FONT_WEIGHT: FontWeight = '400';
export const COLOR_WITH_SCHEMA_DARK: Color = 'light';
export const COLOR_WITH_SCHEMA_LIGHT: Color = 'blue';

export const colorSchemaMapping = {
  [COLOR_SCHEMA_DARK]: COLOR_WITH_SCHEMA_DARK,
  [COLOR_SCHEMA_DARK_LIGHT]: COLOR_WITH_SCHEMA_DARK,
  [COLOR_SCHEMA_LIGHT]: COLOR_WITH_SCHEMA_LIGHT,
};

// EXPORT all INTERFACES of managed COMPONENTS
export { IMatchChangeHp } from './match-change-hp';
export { IMatchChangeLmp } from './match-change-lmp';

// COMBINE all VARIANTS exported from MATCH CHANGE COMPONENTS
export const MatchChangeVariantList: Array<MatchChangeVariant> = [MATCH_CHANGE_TYPE_LMP, MATCH_CHANGE_TYPE_HP];
export type MatchChangeVariant = typeof MATCH_CHANGE_TYPE_LMP | typeof MATCH_CHANGE_TYPE_HP;

const MatchChange: React.FC<IMatchChangeLmp | IMatchChangeHp> = (props) =>
  props.variant === 'lmp' ? (
    <MatchChangeLmp {...(props as IMatchChangeLmp)} />
  ) : (
    <MatchChangeHp {...(props as IMatchChangeHp)} />
  );

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  MatchChange.propTypes = MatchChangeHp.propTypes;
}
export default MatchChange;
